"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkInternalReferences = exports.internalReferenceErrorStr = exports.generateStubLinkReport = void 0;
const _ = __importStar(require("lodash"));
/* Generate a CSV formatted string where each line contains the indoor map ID and the list of stub
 * links it references
 */
const generateStubLinkReport = (results) => Object.entries(results)
    .filter(([_indoorMapId, result]) => result.stubs && result.stubs.length > 0)
    .map(([indoorMapId, result]) => `${indoorMapId},${result.stubs.join(',')}`)
    .join('\n');
exports.generateStubLinkReport = generateStubLinkReport;
const internalReferenceErrorStr = (error) => {
    const { feature: { momType, id }, referenceId, field } = error;
    return `${momType} id "${id}" internal reference "${referenceId}" on property field ${field} is not found`;
};
exports.internalReferenceErrorStr = internalReferenceErrorStr;
/**
 * Check that internal references of indoorMap features refer to existing features. Does not verify the
 * MomFeature structure member validity.
 *
 * External references (consisting only of digits) on Address.parentPointAddressId and Address.routingPoints.road
 * are no checked. Value "not_available" in Address.parentPointAddressId is ignored.
 */
const checkInternalReferences = (indoorMap) => {
    const featuresById = _.groupBy(indoorMap.features, (feature) => feature.id);
    const errors = [];
    const checkReference = (feature, reference, field, skip) => {
        if (skip && skip(reference?.id)) {
            return;
        }
        if (reference?.id) {
            const referred = _.get(featuresById, reference.id)?.at(0);
            if (!referred) {
                errors.push({
                    feature,
                    referenceId: reference.id,
                    field,
                });
            }
        }
    };
    const checkReferences = (feature, references, field) => {
        for (const reference of references || []) {
            checkReference(feature, reference, field);
        }
    };
    for (const feature of indoorMap.features) {
        switch (feature?.momType) {
            case 'indoor.Structure':
                checkReference(feature, feature.properties?.address, 'address');
                break;
            case 'indoor.Level': {
                const { address, structure, topologies, laneGroups, roadSigns, floorMarkings, parentIndoorLevel } = feature.properties;
                checkReference(feature, address, 'address');
                checkReference(feature, structure, 'structure');
                checkReferences(feature, topologies, 'topologies');
                checkReferences(feature, laneGroups, 'laneGroups');
                checkReferences(feature, roadSigns, 'roadSigns');
                checkReferences(feature, floorMarkings, 'floorMarkings');
                checkReference(feature, parentIndoorLevel, 'parentIndoorLevel');
                break;
            }
            case 'Address': {
                if (feature.properties.category === 'MicroPA') {
                    const { parentPointAddressId, parentMicroPointAddressId, routingPoints } = feature.properties;
                    checkReference(feature, parentPointAddressId, 'parentPointAddressId', (id) => !!id?.match(/^([0-9]+)|(not_available)$/));
                    checkReference(feature, parentMicroPointAddressId, 'parentMicroPointAddressId');
                    for (const { road } of routingPoints || []) {
                        checkReference(feature, road, 'routingPoints.road', (id) => !!id?.match(/^[0-9]+$/));
                    }
                }
                break;
            }
            case 'indoor.Space': {
                const { level, parentSpace, spaceAddress } = feature.properties;
                checkReference(feature, level, 'level');
                checkReference(feature, parentSpace, 'parentSpace');
                checkReference(feature, spaceAddress, 'spaceAddress');
                break;
            }
            case 'indoor.SpaceGroups': {
                const { spaceGroups, commonalityGroups } = feature.properties;
                for (const group of spaceGroups || []) {
                    checkReference(feature, group.mainSpace, 'spaceGroups.mainSpace');
                    checkReferences(feature, group.spaces, 'spaceGroups.spaces');
                }
                for (const group of commonalityGroups || []) {
                    checkReference(feature, group.mainSpace, 'commonalityGroups.mainSpace');
                    checkReferences(feature, group.spaces, 'commonalityGroups.spaces');
                }
                break;
            }
            case 'indoor.Occupant': {
                const { spaces, placeReference } = feature.properties;
                checkReferences(feature, spaces, 'spaces');
                checkReference(feature, placeReference, 'placeReference');
                break;
            }
            case 'indoor.Entrance': {
                const { level, address } = feature.properties;
                checkReference(feature, level, 'level');
                checkReference(feature, address, 'address');
                break;
            }
            case 'indoor.LevelConnector': {
                const { spaces, connectingTopologies } = feature.properties;
                checkReferences(feature, spaces, 'spaces');
                for (const { levels, topology } of connectingTopologies || []) {
                    checkReferences(feature, levels, 'connectingTopologies.levels');
                    checkReference(feature, topology, 'connectingTopologies.topology');
                }
                break;
            }
        }
    }
    return errors;
};
exports.checkInternalReferences = checkInternalReferences;
